<nb-card>
	<nb-card-body>
		<form [formGroup]="form" *ngIf="form">
			<ga-location-form
				#locationFormDirective
				[form]="form"
				[showAutocompleteSearch]="true"
				(mapCoordinatesEmitter)="onCoordinatesChanges($event)"
				(mapGeometryEmitter)="onGeometrySend($event)"
			>
			</ga-location-form>
			<ga-leaflet-map
				#leafletTemplate
				(mapClicked)="onMapClicked($event)"
			>
			</ga-leaflet-map>

			<div class="actions">
				<button
					[disabled]="this.form.invalid"
					(click)="submitForm()"
					nbButton
					status="success"
				>
					{{ 'BUTTONS.SAVE' | translate }}
				</button>
			</div>
		</form>
	</nb-card-body>
</nb-card>
